import { render, staticRenderFns } from "./zykPrice.vue?vue&type=template&id=4f3e9044&scoped=true"
import script from "./zykPrice.vue?vue&type=script&lang=js"
export * from "./zykPrice.vue?vue&type=script&lang=js"
import style0 from "./zykPrice.vue?vue&type=style&index=0&id=4f3e9044&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e9044",
  null
  
)

export default component.exports